import React, { useEffect, useState, useRef } from "react";
import { withNamespaces } from "react-i18next";
import filterFactory, { selectFilter } from 'react-bootstrap-table2-filter';
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CardTitle,
    CardSubtitle,
    Container,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
} from "reactstrap";
import exportFromJSON from "export-from-json";
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";

const AllStore = (props) => {
  const { SearchBar } = Search;
const [editModal, setEditModal] = useState(false);
const [selectedStore, setSelectedStore] = useState();
function afterFilter(newResult, newFilters) {
  setExportdata(prevOrders => {
    return JSON.stringify(prevOrders) !== JSON.stringify(newResult) ? newResult : prevOrders;
  });
}
    useEffect(() => {
        loadAllStore();
        loadAllBranchCategories();
    }, []);
    const [allBranchCategories, setAllBranchCategories] = useState([]);
    const loadAllBranchCategories = async () => {
      let url = process.env.REACT_APP_BASEURL + "branchcategories/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        setAllBranchCategories(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    };
    const [allStore, setAllStore] = useState([]);
    const [exportData, setExportdata] = useState([]);
    const loadAllStore = async (e, v) => {
        let url = process.env.REACT_APP_BASEURL + "stores/getall";
        let response = await postSubmitForm(url, "");
        if (response.status === 1) {
            setAllStore(response.data);
            setExportdata(response.data);
        } else {
            showNotification(response.message, "Error");
        }
    };
 
    const [isPrivileged, setIsPrivileged] = useState(false);
    const [isStore, setIsStore] = useState(false);

    const handleValidUpdate = async (e, v) => {
        try {
          let object = {
            id: selectedStore._id,
            name: v.name,
            address: v.address,
            type: v.type,
          };
          if (v.type === 'Branch') {
            object = {
                ...object,
                opening_time: v.opening_time,
                closing_time: v.closing_time,
                branch_category: v.branch_category,
                is_store: isStore,
                transfer_privilege: isPrivileged,
            };
        }

          let url = process.env.REACT_APP_BASEURL + "stores/update";
          let response = await postSubmitForm(url, object);
          if (response.status === 1) {
            loadAllStore();
            setEditModal(!editModal);
            setIsPrivileged(false)
            showNotification(response.message, "Success");
          } else {
            showNotification(response.message, "Error");
          }
        } catch (error) {
          showNotification(error.message, "Error");
        }
      };
    function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          var result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }
  const [storeType, setStoreType] = useState("");
    const columns = [
        {
            text: "#",
            dataField: "_id",
            formatter: (cell, row, rowIndex) => {
                return rowIndex + 1
            },
            headerStyle: (colum, colIndex) => {
                return { width: "3%" };
            },
            //   hidden: true,
        },
        {
            text: props.t("Name"),
            //formatter: employeeFormatter,
            dataField: "name",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "16%" };
            },
        },
        {
            text: props.t("Type"),
            dataField: "type",
            sort: true,
            filter: selectFilter({
              options: [
                { value: "Branch", label: "Branch" },
                { value: "Main Store", label: "Main Store" },
                { value: "Sub Store", label: "Sub Store" },
                { value: "CENTRAL STORE", label: "CENTRAL STORE" },
                { value: "CENTRAL KITCHEN STORE", label: "CENTRAL KITCHEN STORE" },
                { value: "EQUIPMENT STORE", label: "EQUIPMENT STORE" },
              ],
              placeholder: "ALL",
              style: {margin:"8px" },
              onFilter: (value) => {
                setStoreType( value )
              } 
            }),
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
            text: props.t("Address"),
            dataField: "address",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "20%" };
            },
        },
        {
            text: props.t("Branch Category"),
            dataField: "branch_category",
            sort: true,
            filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allBranchCategories.map(({ name: value }) => ({
                    value: value,
                    label: value,
                  }))
                ),
              ].map((product) => [product["value"], product])
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
        placeholder:"All",
        onFilter:(data)=>{
          // console.log(data);
          
        }
      }),
          headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
          dataField: "is_store",
          text: props.t("Store Exist"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "7%" };
          },
          formatter: (cell, row) => {
            return row.type === "Branch" ? row.is_store ? "Yes" : "No" : ""
          },
        },
        {
          dataField: "transfer_privilege",
          text: props.t("Transfer Privilege"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "9%" };
          },
          formatter: (cell, row) => {
            return row.type === "Branch" ? row.transfer_privilege ? "Yes" : "No" : ""
          },
        },
        {
          text: props.t("Status"),
          dataField: "is_active",
          sort: true,
          formatter:(cell,row)=>{
return (
  row.is_active ? (
    <span class="font-size-12 badge-soft-success badge badge-success badge-pill">
      {props.t("Active")}
    </span>
  ) : (
    <span class="font-size-12 badge-soft-danger badge badge-danger badge-pill">
      {props.t("Inactive")}
    </span>
  )
)
          },
          filter: selectFilter({
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
            placeholder: "ALL",
            style: {margin:"8px" },
          }),
          headerStyle: (colum, colIndex) => {
              return { width: "8%" };
          },
      },
        {
            text: props.t("Action"),
            sort: false,
            formatter: (cell, row) => {
              return (
               row.type !=="CENTRAL STORE" && 
               row.type !=="CENTRAL KITCHEN STORE" && 
               row.type !=="EQUIPMENT STORE"  
               ? (
                <span className="text-info">
                <i
                  className="bx bxs-edit font-size-15"
                  title="Click to Edit"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEditModal(!editModal);
                    setSelectedStore(row);
                    setIsStore(row.is_store);
                    setIsPrivileged(row.transfer_privilege);
                  }}
                ></i>
              </span>
               ) : (
                null
               )
              );
            },
            headerStyle: (colum, colIndex) => {
              return { width: "5%" };
            },
          },
    ];

    const handleDownload = async () => {
      const fileName = "All Stores/Branches";
      const exportType = "xls";
  
      let data_to_export =  exportData
  
      if (data_to_export) {
        var data = [];
       data_to_export.forEach(function (v) {
          data.push({
            name: v.name,
            type: v.type,
            mobile: v.mobile ? v.mobile : "",
            email: v.email ? v.email : " ",
            address: v.address,
            branch_category: v.branch_category,
            status: v.is_active ? "Yes" : "No",
            transfer_privilege: v.transfer_privilege ? "Yes" :"No",
          });
        });
  
        exportFromJSON({ data, fileName, exportType });
      }
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={props.t("Store / Branch")}
                        breadcrumbItem={props.t("All Stores/Branch")}
                    />
                
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>

                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                                    <CardTitle>{props.t("Existing Stores/Branch")} </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {props.t("View all your existing stores/branch here")}
                                    </CardSubtitle>
                                    <ToolkitProvider
                    keyField="_id"
                    data={allStore && allStore}
                    columns={columns}
                    search
                  >
                    {(propst) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...propst.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>

                          </Row>
                        </AvForm>
                        <BootstrapTable
                          {...propst.baseProps}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          bootstrap4
                          hover
                          filter={ filterFactory({afterFilter}) } 
                          condensed
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                                    {/* <BootstrapTable
                                        bootstrap4
                                        filter={ filterFactory() } 
                                        keyField="_id"
                                        data={allStore && allStore}
                                        columns={columns}
                                        noDataIndication={props.t("No data to display.")}
                                        striped
                                        hover
                                        condensed
                                    /> */}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal
                    size="lg"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Update Store -")} <strong>{selectedStore?.name}</strong>
                    </ModalHeader>
                    <ModalBody>
                      {selectedStore && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm onValidSubmit={handleValidUpdate}>
                                    <Row>
                                      <Col lg={6}>
                                        <AvField
                                          name="name"
                                          value={selectedStore.name}
                                          label={props.t("Name")}
                                          placeholder={props.t(
                                            "Enter Store Name"
                                          )}
                                          type="text"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Name cannot be empty"
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>

                                      <Col lg={6}>
                                                <AvField
                                                    name="type"
                                                    label={props.t("Type")}
                                                    placeholder={props.t("Enter type")}
                                                    value={selectedStore?.type}
                                                    disabled={true}
                                                    type="select"
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: props.t("Type cannot be empty"),
                                                        },
                                                    }}
                                                >
                                                    {/* <option value="">{props.t("--Select type--")}</option> */}
                                                    <option value="Main Store">{props.t("Main Store")}</option>
                                                    <option value="Sub Store">{props.t("Sub Store")}</option>
                                                    <option value="Branch">{props.t("Branch")}</option>
                                                    <option value="Central Store">{props.t("Central Store")}</option>
                                                </AvField>
                                            </Col>

                                      <Col lg={6}>
                                        <AvField
                                          name="address"
                                          value={selectedStore.address}
                                          label={props.t("Address")}
                                          placeholder={props.t(
                                            "Enter Address "
                                          )}
                                          type="textarea"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Address cannot be empty"
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>

                                    {selectedStore.type==="Branch" && (
                                      <>
                                       <Col lg={6}>
                                       <AvField
                                         name="opening_time"
                                         value={selectedStore.opening_time}
                                         label={props.t("Opening Time")}
                                         placeholder={props.t(
                                           "Enter Opening Time"
                                         )}
                                         type="time"
                                         errorMessage={props.t(
                                           "Opening time cannot be empty"
                                         )}
                                         validate={{
                                           required: { value: true },
                                         }}
                                       />
                                     </Col>
                                     <Col lg={6}>
                                       <AvField
                                         name="closing_time"
                                         value={selectedStore.closing_time}
                                         label={props.t("Closing Time")}
                                         placeholder={props.t(
                                           "Enter Closing Time"
                                         )}
                                         type="time"
                                         errorMessage={props.t(
                                           "Closing time cannot be empty"
                                         )}
                                         validate={{
                                           required: { value: true },
                                         }}
                                       />
                                     </Col>
                                      <Col lg={3}>
                                      <AvRadioGroup
                                        inline
                                        name="is_store"
                                        value={
                                          selectedStore.is_store &&
                                          selectedStore.is_store
                                            ? "true"
                                            : "false"
                                        }
                                        validate={{
                                          required: { value: true },
                                        }}
                                        errorMessage={props.t(
                                          "Select an option"
                                        )}
                                      >
                                        {" "}
                                        <Label>
                                          {props.t("Store Exists?")}
                                        </Label>
                                        <br />
                                        <AvRadio
                                          label={props.t("Yes")}
                                          value="true"
                                          onChange={(e, v) => {
                                            setIsStore(true);
                                          }}
                                        />
                                        <AvRadio
                                          label={props.t("No")}
                                          value="false"
                                          onChange={(e, v) => {
                                            setIsStore(false);
                                          }}
                                        />
                                      </AvRadioGroup>
                                    </Col>
                                        <Col lg={3}>
                                        <AvRadioGroup
                                          inline
                                          name="transfer_privilege"
                                          value={
                                            selectedStore.transfer_privilege &&
                                            selectedStore.transfer_privilege
                                              ? "true"
                                              : "false"
                                          }
                                          validate={{
                                            required: { value: true },
                                          }}
                                          errorMessage={props.t(
                                            "Select an option"
                                          )}
                                        >
                                          {" "}
                                          <Label>
                                            {props.t("Transfer Privileged?")}
                                          </Label>
                                          <br />
                                          <AvRadio
                                            label={props.t("Yes")}
                                            value="true"
                                            onChange={(e, v) => {
                                              setIsPrivileged(true);
                                            }}
                                          />
                                          <AvRadio
                                            label={props.t("No")}
                                            value="false"
                                            onChange={(e, v) => {
                                              setIsPrivileged(false);
                                            }}
                                          />
                                        </AvRadioGroup>
                                      </Col>
                                        <Col lg={6}>
                                        <AvField
                                          type="select"
                                          name="branch_category"
                                          value={selectedStore?.branch_category}
                                          label={props.t("Branch Category")}
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t("branch category is required"),
                                            },
                                          }}
                                        >
                                          <option value="">{props.t("--Select Branch Category--")}</option>
                                          {allBranchCategories.map((data)=>
                                            {return(
                                              <option value={data.name} key={data._id}>{data.name}</option>
                                            )
                                          })}
                                        </AvField>
                                      </Col>
                                      </>
                                    )}
                                     
                                    </Row>
                                    <Row>
                                      <Col lg={12}>
                                        <hr />
                                        <FormGroup className="mb-0 text-center">
                                          <div>
                                            <Button
                                              type="submit"
                                              color="primary"
                                              className="mr-1"
                                            >
                                              {props.t("Update")}
                                            </Button>
                                          </div>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </AvForm>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(connect(null, {})(withNamespaces()(AllStore)));
